import List from "@/modules/manages/roles/view/List"
import { Upsert } from "@/modules/manages/roles/view/Upsert"
import { Route, Routes } from "react-router-dom"

export const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<List />} />
      <Route path=":id" element={<Upsert />} />
    </Routes>
  )
}
